import { PVPApplicationFormSection } from "../PVPApplicationFormSection";
import { useAppSelector } from "@/hooks/reduxHooks";
import { useApiPvpApplicationsSectionsList } from "@/api/lctApIComponents";
import { PVPFormTitle } from "../PVPFormTitle";
import { useUserAppInfo } from "@/hooks/useUserAppInfo";
import { useMemo, forwardRef } from "react";
import { useFormInstances } from "@/hooks/useFormInstances";
interface IProps {
  pvpId: string;
  appId: string;
  userAppId: string;
  formInstances?: ReturnType<typeof useFormInstances>;
}

export const PVPApplicationForm = forwardRef<HTMLDivElement, IProps>(({ pvpId, appId, userAppId, formInstances }, ref) => {
  const token = useAppSelector((state) => state.user.authKey);
  const { currentPart, part1Locked, part2Locked } = useUserAppInfo(userAppId);

  const { data: sections } = useApiPvpApplicationsSectionsList(
    { headers: { Authorization: `Token ${token}` }, pathParams: { app: appId, pvp: pvpId } },
    { enabled: !!appId },
  );

  const { part1Sections, part2Sections } = useMemo(() => {
    return {
      part1Sections: sections?.results.filter((section) => section.part === 1) ?? [],
      part2Sections: sections?.results.filter((section) => section.part === 2) ?? [],
    };
  }, [sections]);

  return (
    <main>
      <PVPFormTitle appId={appId} pvpId={pvpId} />

      <div className="relative space-y-6 overflow-auto">
        <div>
          {part1Sections.map((section) => (
            <div key={section.id} ref={ref}>
              <PVPApplicationFormSection
                key={section.id}
                pvpId={pvpId}
                appId={appId}
                sectionId={section.id}
                userAppId={userAppId}
                fieldsLocked={part1Locked}
                formInstances={formInstances}
              />
            </div>
          ))}
        </div>

        {currentPart === 2 && (
          <div>
            {part2Sections.map((section) => (
              <div key={section.id}>
                <PVPApplicationFormSection
                  pvpId={pvpId}
                  appId={appId}
                  sectionId={section.id}
                  userAppId={userAppId}
                  fieldsLocked={part2Locked}
                  formInstances={formInstances}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </main>
  );
});

PVPApplicationForm.displayName = "PVPApplicationForm";
